import { render, staticRenderFns } from "./tapes_expansion.vue?vue&type=template&id=2f7e27cb&scoped=true&"
import script from "./tapes_expansion.vue?vue&type=script&lang=js&"
export * from "./tapes_expansion.vue?vue&type=script&lang=js&"
import style0 from "./tapes_expansion.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tapes_expansion.vue?vue&type=style&index=1&id=2f7e27cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e27cb",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7e27cb')) {
      api.createRecord('2f7e27cb', component.options)
    } else {
      api.reload('2f7e27cb', component.options)
    }
    module.hot.accept("./tapes_expansion.vue?vue&type=template&id=2f7e27cb&scoped=true&", function () {
      api.rerender('2f7e27cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/tapes_expansion.vue"
export default component.exports